import PrevNextButtonsContainer from "./PrevNextButtonsContainer";

export default PrevNextButtonsContainer;
